import { IReturn, IPost, IPut, IDelete } from './dtos';
export class StudyApplication
  implements IReturn<StudyApplicationResponse>, IPost, IPut {
  public appId: number;
  public userId: string;
  public sessionID: string;
  public culturedIslets: boolean;
  public isletsReqReason: string;
  public frozenIslets: boolean;
  public rationaleFrozen: string;
  public histoSlides: boolean;
  public rationaleHistoSlides: string;
  public acinar: boolean;
  public rationaleAcinar: string;
  public rationaleBlood: string;
  public rationaleAncillary: string;
  public study_Title: string;
  public projAbstract: string;
  public researchMethods: string;
  public bloodProd: boolean;
  public serum: boolean;
  public plasma: boolean;
  public ancillary: boolean;
  public lymphNode: boolean;
  public spleen: boolean;
  public duodenum: boolean;
  public frozenPancreaticPcs: boolean;
  public ductal: boolean;
  public pilot: boolean;
  public iAIPrevApproved: boolean;
  public isletsFunded: boolean;
  public positionGrantAutoElig: boolean;
  public non_Profit: boolean;
  public peer_Rev_Grant: boolean;
  public fundsAva: boolean;
  public pI_Name: string;
  public firstName: string;
  public lastName: string;
  public middleInitial: string;
  public pI_Email: string;
  public institution: string;
  public title: string;
  public pI_Phone: string;
  public pI_Phone_Ext: string;
  public textMsg: boolean;
  public pI_Cell: string;
  public provider_ID: string;
  public pI_Address_1: string;
  public pI_Address_2: string;
  public pI_City: string;
  public country: string;
  public pI_Zip: string;
  public pI_State: string;
  public pI_State_Oth: string;
  public pI_Province: string;
  public time_Zone: string;
  public timeZoneOther: string;
  public wKShipment: boolean;
  public wksameasMailing: boolean;
  public shippingNote: string;
  public exp_Ship_Acct: string;
  public exp_Ship_Acct_2: string;
  public exp_Ship: string;
  public exp_Ship_2: string;
  public eori: string;
  public sameasMailing: boolean;
  public shipCountry: string;
  public ship_Addr_1: string;
  public ship_Addr_2: string;
  public ship_City: string;
  public ship_State: string;
  public ship_Province: string;
  public ship_State_Oth: string;
  public ship_Zip: string;
  public wK_Contact: string;
  public wkShipCountry: string;
  public wK_Ship_Addr_1: string;
  public wK_Ship_Addr_2: string;
  public wK_Ship_City: string;
  public wK_Ship_State: string;
  public wK_Ship_Province: string;
  public wK_Ship_State_Oth: string;
  public wK_Ship_Zip: string;
  public wK_Phone: string;
  public listScientists: string;
  public pIconsulted: boolean;
  public pIagreement: boolean;
  public consulted: boolean;
  public policies: boolean;
  public allNonProfit: boolean;
  public coPIReason: string;
  public iacuC_Status: string;
  public iacuC_App_No: string;
  public iacuC_App_Dt: string;
  public cellStimulus: boolean;
  public cellDeath: boolean;
  public type1Diabetes: boolean;
  public tissueEngineering: boolean;
  public alphaCells: boolean;
  public geneticsGenomics: boolean;
  public otherArea: boolean;
  public otherAreaText: string;
  public begin_Dt: string;
  public comp_Dt: string;
  public ieQs_Ideal: string;
  public ieQs_Min: string;
  public purity_Ideal: string;
  public purity_Min: string;
  public viability_Ideal: string;
  public viability_Min: string;
  public freq_Ideal: string;
  public freq_Min: string;
  public tot_IEQs_Needed: string;
  public cultured_Ideal: string;
  public cultured_Min: string;
  public diabetic_Ideal: string;
  public diabetic_Min: string;
  public race: boolean;
  public aian: string;
  public black: string;
  public nhpi: string;
  public asian: string;
  public hispanic: string;
  public white: string;
  public race_Oth: string;
  public hasORCID: boolean;
  public rsnNoORCID: string;
  public orcid: string;
  public cultureLen: boolean;
  public cultureMinDay: string;
  public cultureMinHr: string;
  public cultureMaxDay: string;
  public cultureMaxHr: string;
  public bmi: boolean;
  public bmiMin1: string;
  public bmiMax1: string;
  public bmiMin2: string;
  public bmiMax2: string;
  public donorAge: boolean;
  public donorAgeMin: string;
  public donorAgeMax: string;
  public genderYN: boolean;
  public genderPref: string;
  public moved: boolean;
  public typeofStudy: string;
  public submit: string;
  public personId: number;
  public animalResearch: boolean;
    public urn: string;
    // public meeting: boolean;
    // public meetingSpecify: string;
    // public meetingOther: string;

  public constructor(init?: Partial<StudyApplication>) {
    (Object as any).assign(this, init);
  }

  public createResponse() {
    return new StudyApplicationResponse();
  }

  public getTypeName() {
    return 'CreateStudyApplication';
  }
}

export class StudyApplicationResponse {
  public result: StudyApplicationBase;

  public constructor(init?: Partial<StudyApplicationResponse>) {
    (Object as any).assign(this, init);
  }
}

export class StudyApplicationBase {
  appId: 0;
  study_Title: '';
  projAbstract: '';
  culturedIslets: false;
  isletsReqReason: '';
  frozenIslets: false;
  rationaleFrozen: '';
  histoSlides: false;
  rationaleHistoSlides: '';
  acinar: false;
  rationaleAcinar: '';
  rationaleBlood: '';
  rationaleAncillary: '';
  bloodProd: false;
  serum: false;
  plasma: false;
  ancillary: false;
  lymphNode: false;
  spleen: false;
  duodenum: false;
  frozenPancreaticPcs: false;
  ductal: false;
  pilot: false;
  iAIPrevApproved: false;
  isletsFunded: false;
  positionGrantAutoElig: false;
  non_Profit: false;
  peer_Rev_Grant: false;
  fundsAva: false;
  pI_Name: '';
  firstName: '';
  lastName: '';
  middleInitial: '';
  pI_Email: '';
  institution: '';
  title: '';
  pI_Phone: '';
  pI_Phone_Ext: '';
  textMsg: false;
  pI_Cell: '';
  provider_ID: '';
  pI_Address_1: '';
  pI_Address_2: '';
  pI_City: '';
  country: '';
  pI_Zip: '';
  pI_State: '';
  pI_State_Oth: '';
  pI_Province: '';
  time_Zone: '';
  timeZoneOther: '';
  wKShipment: false;
  shippingNote: '';
  exp_Ship: '';
  exp_Ship_2: '';
  exp_Ship_Acct: '';
  exp_Ship_Acct_2: '';
  eori: '';
  sameasmailing: false;
  wksameasmailing: false;
  shipCountry: '';
  ship_Addr_1: '';
  ship_Addr_2: '';
  ship_City: '';
  ship_State: '';
  ship_Province: '';
  ship_State_Oth: '';
  ship_Zip: '';
  wK_Contact: '';
  wkShipCountry: '';
  wK_Ship_Addr_1: '';
  wK_Ship_Addr_2: '';
  wK_Ship_City: '';
  wK_Ship_State: '';
  wK_Ship_Province: '';
  wK_Ship_State_Oth: '';
  wK_Ship_Zip: '';
  wK_Phone: '';
  listScientists: false;
  pIconsulted: false;
  pIagreement: false;
  consulted: false;
  policies: false;
  allNonProfit: false;
  coPIReason: '';
  researchMethods: '';
  iacuC_Status: '';
  iacuC_App_No: '';
  iacuC_App_Dt: '';
  cellStimulus: false;
  cellDeath: false;
  type1Diabetes: false;
  tissueEngineering: false;
  alphaCells: false;
  geneticsGenomics: false;
  otherArea: false;
  otherAreaText: '';
  begin_Dt: '';
  comp_Dt: '';
  ieQs_Ideal: '';
  ieQs_Min: '';
  purity_Ideal: '';
  purity_Min: '';
  viability_Ideal: '';
  viability_Min: '';
  freq_Ideal: '';
  freq_Min: '';
  tot_IEQs_Needed: '';
  cultured_Ideal: '';
  cultured_Min: '';
  diabetic_Ideal: '';
  diabetic_Min: '';
  frozen_Ideal: '';
  frozen_Min: '';
  frozen_Min_IEQs: '';
  frozen_Max_IEQs: '';
  race: false;
  aian: '';
  black: '';
  nhpi: '';
  asian: '';
  hispanic: '';
  white: '';
  race_Oth: '';
  hasORCID: false;
  rsnNoORCID: '';
  orcid: '';
  cultureLen: false;
  cultureMinDay: '';
  cultureMinHr: '';
  cultureMaxDay: '';
  cultureMaxHr: '';
  BMI: false;
  bmiMin1: '';
  bmiMax1: '';
  bmiMin2: '';
  bmiMax2: '';
  donorAge: false;
  donorAgeMin: '';
  donorAgeMax: '';
  genderYN: false;
  genderPref: '';
  typeofStudy: '';
  submit: '';
  moved: false;
  personId: '';
  animalResearch: false;
  urn: '';
}

export class StudyProgressBase {
  appID: 0;
  userId: '';
  Section: '';
  status: '';
}

export class StudyProgress implements IReturn<StudyProgressResponse>, IPost {
  public progress: any;
  public constructor(init?: Partial<StudyProgress>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new StudyProgressResponse();
  }
  public getTypeName() {
    return 'AddStudyProgressRequest';
  }
}

export class StudyProgressResponse {
  public result: StudyProgressBase;
  public constructor(init?: Partial<StudyProgressResponse>) {
    (Object as any).assign(this, init);
  }
}
export class DegreeSelection
  implements IReturn<DegreeSelectionResponse>, IPost {
  public appId: 0;
  public degreeList: [];
  public degreeOther: '';

  public constructor(init?: Partial<DegreeSelection>) {
    (Object as any).assign(this, init);
  }

  public createResponse() {
    return new DegreeSelectionResponse();
  }

  public getTypeName() {
    return 'AddDegreeList';
  }
}

export class DegreeSelectionResponse {
  public result: '';
  public constructor(init?: Partial<DegreeSelectionResponse>) {
    (Object as any).assign(this, init);
  }
}

export class InvestigatorDegreeBase {
  rowId: 0;
  appId: 0;
  code: 0;
  other: '';
}


export class ReferralSelection implements IReturn<ReferralSelectionResponse>, IPost {
    public appId: 0;
    public userId: '';
    public referralList: [];
    public referralOther: '';
    public meeting: '';
    public meetingOther: '';

    constructor(init?: Partial<ReferralSelection>) {
        Object.assign(this, init);
    }
    createResponse() { return new ReferralSelectionResponse(); }
    getTypeName() { return 'AddReferralList'; }
}

export class ReferralSelectionResponse {
    public result: string = '';
    constructor(init?: Partial<ReferralSelectionResponse>) {
        Object.assign(this, init);
    }
}

export class InvestigatorRefferalBase {
  rowId: 0;
  appId: 0;
  userId: '';
  source: 0;
  sourceOth: '';
}
export class StudyMiscDoc implements IReturn<StudyMiscDocResponse>, IPost {
  public appId: string;
  public docType: number;
  public files: any;
  public constructor(init?: Partial<StudyMiscDoc>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new StudyMiscDocResponse();
  }
  public getTypeName() {
    return 'CreateStudyFile';
  }
}

export class AddStudyMiscDoc
  implements IReturn<AddStudyMiscDocResponse>, IPost {
  public docId: number;
  public appId: number;
  public docType: number;
  public docName: string;
  public docUniqueName: string;
  public docLength: string;
  public constructor(init?: Partial<AddStudyMiscDoc>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new AddStudyMiscDocResponse();
  }
  public getTypeName() {
    return 'AddStudyMiscDoc';
  }
}

export class AddStudyMiscDocResponse {
  public result: StudyMiscDocBase;
  public constructor(init?: Partial<AddStudyMiscDoc>) {
    (Object as any).assign(this, init);
  }
}

export class DeleteStudyMiscDoc
  implements IReturn<DeleteStudyMiscDocResponse>, IDelete {
  public docId: string;
  public appId: string;
  public constructor(init?: Partial<DeleteStudyMiscDoc>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new DeleteStudyMiscDocResponse();
  }
  public getTypeName() {
    return 'DeleteStudyFile';
  }
}

export class DeleteStudyMiscDocResponse {
  public docs: any;
  public constructor(init?: Partial<DeleteStudyMiscDocResponse>) {
    (Object as any).assign(this, init);
  }
}
export class StudyMiscDocResponse {
  public result: StudyMiscDocBase[];

  public constructor(init?: Partial<StudyMiscDocResponse>) {
    (Object as any).assign(this, init);
  }
}
export class StudyMiscDocBase {
  docId: 0;
  appId: '';
  docType: '';
  docName: '';
  docUniqueName: '';
  docLength: '';
}

/* Grants */
export class Grants implements IReturn<GrantsResponse>, IPost {
  public rowId: number;
  public appID: number;
  public grantTitle: string;
  public fundingSource: string;
  public grantNo: string;
  public startDt: string;
  public duration: string;
  public awardAmt: string;
  public supportType: string;
  public supportTypeOth: string;
  public constructor(init?: Partial<Grants>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new GrantsResponse();
  }
  public getTypeName() {
    return 'AddGrantRequest';
  }
}

export class GrantsResponse {
  public result: GrantBase;
  public constructor(init?: Partial<Grants>) {
    (Object as any).assign(this, init);
  }
}

export class DeleteGrant implements IReturn<DeleteGrantResponse>, IDelete {
  public rowId: number;
  public appId: number;
  public constructor(init?: Partial<DeleteGrant>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new DeleteGrantResponse();
  }
  public getTypeName() {
    return 'DeleteGrant';
  }
}
export class DeleteGrantResponse {
  public grantList: any;
  public constructor(init?: Partial<DeleteGrantResponse>) {
    (Object as any).assign(this, init);
  }
}
export class EditGrant implements IReturn<EditGrantResponse>, IPut {
  public rowId: number;
  public appID: number;
  public grantTitle: string;
  public fundingSource: string;
  public grantNo: string;
  public startDt: string;
  public duration: string;
  public awardAmt: string;
  public supportType: string;
  public supportTypeOth: string;
  public constructor(init?: Partial<EditGrant>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new EditGrantResponse();
  }
  public getTypeName() {
    return 'EditGrant';
  }
}

export class EditGrantResponse {
  public grantList: any;
  public constructor(init?: Partial<EditGrantResponse>) {
    (Object as any).assign(this, init);
  }
}
export class GrantBase {
  appId: 0;
  rowId: 0;
  grantTitle: '';
  fundingSource: '';
  grantNo: '';
  startDt: '';
  duration: '';
  awardAmt: '';
  supportType: '';
  supportTypeOth: '';
}
/* CenterBlocking */
export class AddCenterBlockingRequest
  implements IReturn<AddCenterBlockingResponse>, IPut {
  public rowId: number;
  public appID: number;
  public institution_Id: string;
  public reason: string;
  public reasonOth: string;
  public constructor(init?: Partial<AddCenterBlockingRequest>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new AddCenterBlockingResponse();
  }
  public getTypeName() {
    return 'AddCenterBlockingRequest';
  }
}
export class AddCenterBlockingResponse {
  public centerBlockingList: any;
  public constructor(init?: Partial<AddCenterBlockingRequest>) {
    (Object as any).assign(this, init);
  }
}

export class DeleteCenterBlocking
  implements IReturn<DeleteCenterBlockingResponse>, IDelete {
  public rowId: number;
  public appId: number;
  public constructor(init?: Partial<DeleteCenterBlocking>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new DeleteCenterBlockingResponse();
  }
  public getTypeName() {
    return 'DeleteCenterBlocking';
  }
}
export class DeleteCenterBlockingResponse {
  public centerBlockingList: any;
  public constructor(init?: Partial<DeleteCenterBlockingResponse>) {
    (Object as any).assign(this, init);
  }
}
export class CenterBlockingBase {
  appId: 0;
  rowId: 0;
  institution_Id: '';
  reason: '';
  reasonOth: '';
}

/* Wireless Provider */
export class WirelessProvider
  implements IReturn<WirelessProviderResponse>, IPost {
  public provider_ID: number;
  public provider_Name: string;
  public provider_Ext: string;
  public constructor(init?: Partial<WirelessProvider>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new WirelessProviderResponse();
  }
  public getTypeName() {
    return 'WirelessProvider';
  }
}

export class WirelessProviderResponse {
  public result: WirelessProviderBase;
  public constructor(init?: Partial<WirelessProvider>) {
    (Object as any).assign(this, init);
  }
}
export class WirelessProviderBase {
  provider_ID: 0;
  provider_Name: '';
  provider_Ext: '';
}
/* IAI Eligibility */
export class EligibilityRequest implements IReturn<EligibilityResponse>, IPost {
  public eligibilityList: any;
  public rowId: number;
  public userId: string;
  public everApproved: boolean;
  public isletFunds: boolean;
  public r01Eligible: boolean;
  public constructor(init?: Partial<EligibilityRequest>) {
    (Object as any).assign(this, init);
  }
  public createResponse() {
    return new EligibilityResponse();
  }
  public getTypeName() {
    return 'AddEligibilityRequest';
  }
}
export class EligibilityResponse {
  public result: EligibilityBase;
  public constructor(init?: Partial<EligibilityRequest>) {
    (Object as any).assign(this, init);
  }
}
export class EligibilityBase {
  rowId: 0;
  userId: '';
  everApproved: false;
  isletFunds: false;
  r01Eligible: false;
}

